import { IState } from 'core';
import { IBetRepeatState } from './types';

export const betRepeatRootSelector = (state: IState): IBetRepeatState => state.betRepeatReducer;
